export default __webpack_public_path__ + "static/media/total-bg-1920.766cd69b.svg";